import { useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import { isCheckoutSettling, subscriptionMeOptions } from '@/entities/subscription';
import { emailVerificationStatusOptions } from '@/entities/user';

export function useUpgradeNotice(checkoutSessionId: string | undefined) {
    const { data: subscription } = useQuery(subscriptionMeOptions());
    const { data: emailStatus } = useQuery(emailVerificationStatusOptions());
    const [isDismissed, setIsDismissed] = useState(false);
    const [wasActivated, setWasActivated] = useState(false);

    // Driven by the settled subscription rather than a WebSocket push: the Stripe redirect unloads
    // the app, so a push sent while it reconnects reaches zero connections and is dropped.
    const isActivation =
        !!checkoutSessionId &&
        subscription?.isTrial === false &&
        !isCheckoutSettling(subscription, checkoutSessionId);

    // Latched during render, not in an effect: settling drops checkout_session_id on the very
    // update that satisfies this, and the dialog has to open on the same commit.
    if (isActivation && !wasActivated) {
        setWasActivated(true);
    }

    return {
        // Only the activation latches — the verification answer may land after the param is gone,
        // and verifying in another tab should close the notice.
        isOpen: wasActivated && emailStatus?.verified === false && !isDismissed,
        email: emailStatus?.email,
        dismiss: () => setIsDismissed(true),
    };
}
